// PROFILE
export const POST_EDIT_PROFILE = '/user';

// Ecommerce
// Orders
export const ADD_ORDERS = '/add-orders';
export const UPDATE_ORDERS = '/edit-orders';
export const DELETE_ORDERS = '/delete-orders';

// Sellers
export const GET_SELLERS = '/get-sellers';
export const ADD_SELLERS = '/add-sellers';
export const UPDATE_SELLERS = '/edit-sellers';
export const DELETE_SELLERS = '/delete-sellers';

// Products
// List View
export const GET_PRODUCT_LIST = '/get-product-list';
export const ADD_PRODUCT_LIST = '/add-product-list';
export const UPDATE_PRODUCT_LIST = '/edit-product-list';
export const DELETE_PRODUCT_LIST = '/delete-product-list';

// Grid View
export const GET_PRODUCTS = 'api/products/search';
export const GET_PRODUCT_DETAIL = 'api/products';
export const EXCHANGE_RATE = 'api/public/exchange-rates';

// USER
export const GET_USER = 'api/user/me';
// THEME
export const GET_THEME = 'api/public/homepage/themes';

// SHIPPING
export const GET_SHIPPING = 'api/public/shipping-config';

// Category
export const GET_CATEGORY = 'api/public/categories';

// Orders
export const GET_ORDERS = 'api/orders';
